<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>区域管理</el-breadcrumb-item>
      <el-breadcrumb-item>区域列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-button v-code="29101" type="primary" size="mini" @click="handleNew"
        >新增区域</el-button
      >
      <el-table :data="list" size="small" class="mt-10">
        <el-table-column prop="name" label="区域名称"> </el-table-column>
        <el-table-column prop="name" label="创建时间" align="center">
          <template slot-scope="scope">
            {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-code="29102"
              type="text"
              size="small"
              class="ml-10"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <Former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></Former>
    </div>
  </div>
</template>

<script>
import { regionList } from '@/service/getData'
import Former from './former'

export default {
  components: {
    Former,
  },
  data() {
    return {
      model: {},
      editIndex: 0,
      list: [],
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await regionList({})
      if (res.code == 0) {
        this.list = res.data.list
      }
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleNew() {
      this.model = {
        name: '',
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.model = {
          id: item.id,
          name: item.name,
        }
        this.editIndex = index
      })
    },
  },
}
</script>